<template>
    <div class="page">
        <!-- <img :src="Images.login_bg_img" class="login-bg-img" /> -->
        <div class="home-btn" @click="toHome">
            <img :src="Images.icon_home" />
        </div>
        <div class="logo-box">
            <img :src="Images.icon_logo" class="logo" />
        </div>
        <div class="login-dialog">
            <img :src="Images.icon_logo" class="bg" />
            <div class="tab td-fsc">
                <div :class="{active: login_type == 0}" @click="changeType(0)">账号登陆</div>
                <div :class="{active: login_type == 1}" @click="changeType(1)">验证码登录</div>
            </div>
            <div class="login-input">
                <img :src="Images.icon_login_phone" />
                <div class="input">
                    <input type="text" v-model="form.mobile" placeholder="请输入手机号">
                </div>
            </div>
            <div class="login-input" v-if="login_type == 0">
                <img :src="Images.icon_login_password" />
                <div class="input">
                    <input type="password" v-model="form.password" placeholder="请输入密码">
                </div>
            </div>
            <div class="login-input" v-if="login_type == 1">
                <img :src="Images.icon_login_code">
                <div class="input">
                    <input type="text" placeholder="请输入验证码" v-model="form.sms_code">
                </div>
                <div class="code" @click="getCode">{{ time_text ? time_text : "获取验证码" }}</div>
            </div>
            <div class="login-btn">
                <Btn class="btn" loading @confirmEvent="submitLogin">登录</Btn>
            </div>
            <div class="login-type">
                <router-link :to="`/forget`">忘记密码</router-link>
                <div class="line"></div>
                <router-link :to="`/register`">立即注册</router-link>
            </div>
            <div class="other-login">
                <!-- <div class="other-login-item" @click="qqLogin" v-if="isWeiXin!=='wxwork'">
                    <img :src="Images.qq_icon" />
                    <div>QQ账号登录</div>
                </div> -->
                <div class="other-login-item" @click="wxLogin" v-if="isWeiXin">
                    <img :src="Images.icon_wechat" />
                    <div>微信登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            login_type: 0,
            time: 60,
            time_text: "",
            timer: null,
            // 第三方登录
            isWeiXin: false,
            // 账号登录
            form: {
                mobile: "",
                password: "",
                sms_code: "",
            },
        };
    },
    created() {
        // 微信自动授权登录
        this.$isWeiXin() && this.wxLogin();
    },
    mounted() {
        this.isWeiXin = this.$isWeiXin();

        // 微信自动授权登录
        // if (this.$isWeiXin()) {
        //     setTimeout(() => {
        //         this.wxLogin();
        //     }, 5000)
        // }
    },
    methods: {
        // 切换登录方式
        changeType (type) {
            this.login_type = type
        },
        // 微信授权登录
        wxLogin() {
            let WX_APPID = this.GLOBAL.WX_APPID
            let WX_REDIRECT_URI = encodeURIComponent(this.GLOBAL.WX_REDIRECT_URI)
            let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APPID}&redirect_uri=${WX_REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`
            window.location.replace(url)
        },
        // 微信授权登录
        qqLogin() {
            let QQ_APPID = this.GLOBAL.QQ_APPID
            let QQ_REDIRECT_URI = encodeURIComponent(this.GLOBAL.QQ_REDIRECT_URI)
            let url = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${QQ_APPID}&redirect_uri=${QQ_REDIRECT_URI}&state=2&display=mobile`
            window.location.replace(url)
        },
        // 回到首页
        toHome () {
            this.$router.replace("/");
        },
        // 倒计时
        setTimeOut() {
            this.timer = setInterval(() => {
                this.time--;
                this.time_text = `${this.time}秒后重试`;
                if (this.time == 0) {
                    clearInterval(this.timer);
                    this.time = 60;
                    this.time_text = "获取验证码";
                }
            }, 1000);
        },
        // 获取验证码
        async getCode() {
            if (this.time !== 60) return;
            let { mobile } = this.form;
            if (!mobile) {
                this.Message({
                    title: "请输入手机号",
                });
                return;
            }
            // if (!this.$checkPhone(mobile)) {
            //     this.Message({
            //         title: "手机号输入有误，请重新输入",
            //     });
            //     return;
            // }
            let url = this.API.smsCode;
            let params = {
                code_type: 2,
                mobile: mobile,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: "短信发送成功，请注意查收！",
                });
                this.setTimeOut();
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        async submitLogin(done) {
            let { mobile, password, sms_code } = this.form;
            let _accountIndex = this.Constants.DEV_ACCOUNT.findIndex(item => item === mobile);
            if (_accountIndex > -1) {
                switch(mobile) {
                    case '001':
                        mobile = '15066886001';
                        password = '123123';
                        break;
                    case '002':
                        mobile = '15066886002';
                        password = '123123';
                        break;
                    case '003':
                        mobile = '15066886003';
                        password = '123123';
                        break;
                    case '004':
                        mobile = '15066886004';
                        password = '123123';
                        break;
                    case '005':
                        mobile = '15066886005';
                        password = '123123';
                        break;
                    case '006':
                        mobile = '15066886006';
                        password = '123123';
                        break;
                    case '007':
                        mobile = '15066886007';
                        password = '123123';
                        break;
                    case '008':
                        mobile = '15753965711';
                        password = '123123';
                        break;
                    case '009':
                        mobile = '15910431459';
                        password = '123123';
                        break;
                    case '010':
                        mobile = '13114994744';
                        password = '123123';
                        break;
                }
            }
            // if (!this.$checkPhone(mobile)) {
            //     this.Message({
            //         title: "请输入手机号",
            //     });
            //     return done();
            // }
            if (this.login_type == 0) {
                if (!password) {
                    this.Message({
                        title: "请输入密码",
                    });
                    return done();
                }
            } else {
                if (!sms_code) {
                    this.Message({
                        title: "请输入短信验证码",
                    });
                    return done();
                }
            }
            let url = ""
            let params = {
                mobile: mobile
            };
            if (this.login_type == 0) {
                url = this.API.login
                params.password = password
            } else {
                url = this.API.code_login
                params.sms_code = sms_code
            }
            let result = await this.$post(url, params);
            done()
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                localStorage.setItem("token", result.data.token);
                this.$store.dispatch("UserInfo", true)
                this.Message({
                    title: "登录成功",
                    onClose: ()=>{
                        let backPath = this.Lockr.get('backPath')
                        if (backPath) {
                            this.$router.replace(backPath);
                            this.Lockr.rm('backPath')
                        } else {
                            this.$router.replace("/");
                        }
                    }
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.page{
    min-height: 100vh;
    background-color: #fff;
}
.login-bg-img {
    width: 100%;
    height: 339px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
}
.home-btn{
    position: absolute;
    top: 10px;
    left: 10px;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 1px 6px 0px rgba(157, 157, 157, 0.2);
    img{
        width: 20px;
        height: 20px;
        object-fit: contain;
    }
}
.other-login {
    display: flex;
    width: 100%;
    justify-content: space-around;
    padding-top: 10px;
    .other-login-item {
        flex: 1;
        img {
            display: block;
            margin: 0 auto;
            width: 30px;
            height: 30px;
        }
        div {
            text-align: center;
            margin-top: 9px;
            font-size: 12px;
            color: #acb6ca;
        }
    }
}
.other-type {
    display: flex;
    justify-content: space-between;
    margin: 55px 20px 27px;
    align-items: center;
    .line {
        flex: 1;
        height: 2px;
        border-top: 1px solid #f0f0f0;
    }
    .text {
        font-size: 14px;
        margin: 0 16px;
        color: #999999;
    }
}
.logo-box{
    padding: 30px 0;
    .logo {
        width: 60px;
        height: 60%;
        display: block;
        margin: 0 auto;
        object-fit: contain;
    }
}
.intro {
    font-size: 20px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 27px;
    margin-top: 20px;
}
.login-dialog {
    background-color: rgba(255,255,255,0.88);
    border-radius: 10px;
    margin: 0 20px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
    padding-bottom: 10px;
    position: relative;
    z-index: 2;
    .bg{
        position: absolute;
        top: 6%;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1;
        opacity: 0.08;
        width: 260px;
        height: 260px;
        object-fit: contain;
    }
    .tab {
        padding: 0 10px;
        font-size: 14px;
        counter-reset: #333;
        >div{
            min-width: 90px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.2s;
            &.active{
                font-size: 16px;
                font-weight: 500;
                color: #7181eb;
            }
        }
    }
    .login-input {
        margin: 10px 15px;
        height: 40px;
        padding: 0 5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-bottom: solid #eee 1px;
        .input{
            height: 40px;
            flex: 1;
        }
        input {
            width: 100%;
            font-size: 14px;
            color: #999999;
            line-height: 40px;
        }
        img {
            width: 16px;
            height: 20px;
            margin-right: 15px;
            display: block;
            object-fit: contain;
        }
        .code {
            margin-left: 10px;
            padding-left: 10px;
            font-size: 13px;
            height: 15px;
            color: #7181eb;
            display: flex;
            justify-content: center;
            align-items: center;
            border-left: solid #7181eb 1px;
        }
    }
    .login-type {
        margin: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        .line{
            height: 14px;
            width: 1px;
            background-color: #eee;
            margin: 0 10px;
        }
        a {
            text-decoration: none;
            outline: 0;
            font-size: 13px;
            color: #999999;
        }
    }
    .login-btn {
        margin: 40px 15px 10px;
        .btn{
            display: flex;
            width: 100%;
            height: 40px;
            background: linear-gradient(225deg,#9cb2f4, #6472e8);
            border-radius: 3px;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
        }
    }
}
</style>